import { IResponse, mfa } from '@dto';
import { ModuleDefault } from '../default';

export class Read extends ModuleDefault {
  public getUserMFA (email: string): Promise<IResponse<mfa.IGetUserMFA>> {
    return this.request.get<IResponse<mfa.IGetUserMFA>>(`${this.setup.urlBase}/mfa/${email}`);
  }
}
